import React, { useState } from 'react';
import axios from 'axios';
import { Paperclip } from 'lucide-react';
import { getToken } from '../../utils/tokenStorage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Attach files to a support ticket or reply. Uploads immediately, hands back the list.
export const SupportAttachments = ({ attachments, setAttachments, testId }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const upload = async (files) => {
    setError(''); setUploading(true);
    for (const file of files) {
      const form = new FormData();
      form.append('file', file);
      try {
        const { data } = await axios.post(`${API}/support/attachments`, form, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${getToken()}`, 'Content-Type': 'multipart/form-data' },
        });
        setAttachments(prev => [...prev, data]);
      } catch (e) {
        setError(e.response?.data?.detail || `Could not upload ${file.name}`);
      }
    }
    setUploading(false);
  };

  return (
    <div style={{ marginTop: '8px' }} data-testid={testId}>
      <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '7px 14px', background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: '6px', cursor: uploading ? 'wait' : 'pointer', fontSize: '13px', fontWeight: 600, color: '#374151' }}
        data-testid={`${testId}-btn`}>
        <Paperclip size={14} />
        {uploading ? 'Uploading…' : 'Attach file'}
        <input type="file" multiple disabled={uploading} style={{ display: 'none' }}
          accept="image/*,.pdf,.doc,.docx,.txt,.csv,.xlsx"
          onChange={e => { if (e.target.files?.length) upload(Array.from(e.target.files)); e.target.value = ''; }} />
      </label>
      <span style={{ fontSize: '12px', color: '#9ca3af', marginLeft: '10px' }}>Images, PDF, Word, Excel or text — max 10MB each</span>
      {error && <div style={{ fontSize: '12px', color: '#b91c1c', marginTop: '6px' }}>{error}</div>}
      {attachments.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '10px' }}>
          {attachments.map((a, i) => (
            <span key={a.url} style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '999px', padding: '4px 10px', fontSize: '12px', color: '#1e40af' }}>
              {a.filename}
              <button type="button" onClick={() => setAttachments(prev => prev.filter((_, idx) => idx !== i))}
                style={{ border: 'none', background: 'none', color: '#1e40af', cursor: 'pointer', fontSize: '14px', lineHeight: 1 }}
                data-testid={`${testId}-remove-${i}`}>&times;</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

// Read-only list shown under a sent message
export const AttachmentList = ({ attachments }) => (
  !attachments || attachments.length === 0 ? null : (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }} data-testid="attachment-list">
      {attachments.map(a => (
        a.resource_type === 'image' ? (
          <a key={a.url} href={a.url} target="_blank" rel="noreferrer">
            <img src={a.url} alt={a.filename} style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #e5e7eb' }} />
          </a>
        ) : (
          <a key={a.url} href={a.url} target="_blank" rel="noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'white', border: '1px solid #e5e7eb', borderRadius: '6px', padding: '6px 10px', fontSize: '12px', color: '#1a2332', textDecoration: 'none' }}>
            <Paperclip size={13} /> {a.filename}
          </a>
        )
      ))}
    </div>
  )
);
